import { SRPRS_DEV } from '../env'

export const immutableReconciler = (
  inboundState: any,
  originalState: any,
  reducedState: any,
) => {
  let newState = Object.assign({}, reducedState)
  // only rehydrate if inboundState exists and is an object
  if (isObject(inboundState)) {
    newState = mergeObject(inboundState, originalState, reducedState)
  }

  return newState
}

function mergeObject(
  inboundObject: any,
  originalObject: any,
  reducedObject: any,
) {
  const newObject = Object.assign({}, reducedObject)
  Object.keys(inboundObject).forEach(key => {
    // ignore _persist data
    if (key === '_persist') {
      return
    }
    // if reducer modifies substate, skip auto rehydration
    if (
      originalObject[key] !== reducedObject[key] &&
      !isNaN(originalObject[key])
    ) {
      console.log('Inbound object', inboundObject[key])
      console.log('Original object', originalObject[key])
      console.log('Reduced object', reducedObject[key])
      if (SRPRS_DEV) {
        console.log('persist: sub state for key `%s` modified, skipping.', key)
      }
      return
    }

    if (
      isPlainEnoughObject(reducedObject[key]) &&
      hasObjects(reducedObject[key])
    ) {
      newObject[key] = mergeObject(
        inboundObject[key],
        originalObject[key],
        reducedObject[key],
      )
    } else if (
      betterTypeOf(newObject[key]) === betterTypeOf(inboundObject[key])
    ) {
      newObject[key] = inboundObject[key]
    } else if (betterTypeOf(newObject[key]) === `boolean`) {
      newObject[key] = !!inboundObject[key]
    } else if (betterTypeOf(newObject[key]) === `number`) {
      newObject[key] = +inboundObject[key]
    } else if (betterTypeOf(newObject[key]) === `string`) {
      newObject[key] = `${inboundObject[key]}`
    } else if (newObject[key] === null && inboundObject[key] !== null) {
      newObject[key] = inboundObject[key]
    }
  })
  return newObject
}

const betterTypeOf = (obj: any): string => {
  const isSymFunc: boolean = typeof Symbol === 'function'
  const isSymIter: boolean = typeof Symbol.iterator === 'symbol'

  if (obj && isSymFunc) {
    if (isSymIter && Array.isArray(obj)) {
      return 'array'
    } else if (obj.constructor === Symbol && obj !== Symbol.prototype) {
      return 'symbol'
    }
  }

  return typeof obj
}

function isObject(target: any) {
  return (
    target &&
    (typeof target === 'undefined' ? 'undefined' : betterTypeOf(target)) ===
      'object'
  )
}

function isPlainEnoughObject(o: any) {
  return (
    o !== null &&
    !Array.isArray(o) &&
    (typeof o === 'undefined' ? 'undefined' : betterTypeOf(o)) === 'object'
  )
}

function hasObjects(o: any) {
  return Object.values(o).filter(x => isPlainEnoughObject(x)).length > 0
}
